module.exports = __webpack_public_path__ + "img/upload-dummy.110d7f4a.png";